import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, useUser } from '@clerk/clerk-react';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isLoaded, isSignedIn } = useAuth();
  const { user } = useUser();

  // Show loading state while checking authentication
  if (!isLoaded) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Loading...</p>
      </div>
    );
  }

  // Redirect to sign-in if not authenticated
  if (!isSignedIn) {
    return <Navigate to="/sign-in" replace />;
  }

  // Check if user has admin role (check both is_admin and role for compatibility)
  const isAdmin = user?.publicMetadata?.is_admin === true || user?.publicMetadata?.role === 'admin';

  // Redirect to home if not admin
  if (!isAdmin) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2>Access Denied</h2>
        <p>You do not have permission to access this page.</p>
        <p style={{ fontSize: '12px', color: '#666' }}>
          Debug: is_admin = {String(user?.publicMetadata?.is_admin)}, role = {String(user?.publicMetadata?.role)}
        </p>
        <a href="/">Return to Home</a>
      </div>
    );
  }

  return <>{children}</>;
};

export default AdminRoute;
